import React, { Component } from 'react';
import { createRoot } from 'react-dom/client';
import Header from './header';
import Content from './content';
import Footer from './footer';
import Admin from './admin';
import About from './about';
import Privacy from './privacy';
import CookieNotice from './cookieNotice';
import BackgroundGraph from './backgroundGraph';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import './index.css';

const path = window.location.pathname;

class App extends Component {
  render() {
    if (path === '/quandcest') {
      return (
        <>
          <BackgroundGraph />
          <div className="app-wide d-flex flex-column min-vh-100" data-bs-theme="dark">
            <div className="flex-grow-1">
              <Admin />
            </div>
            <div className="footer mt-auto">
              <Footer />
            </div>
          </div>
        </>
      );
    }

    let pageContent;
    if (path === '/about') {
      pageContent = <About />;
    } else if (path === '/privacy') {
      pageContent = <Privacy />;
    } else {
      pageContent = <Content />;
    }

    return (
      <>
        <BackgroundGraph />
        <div className="app d-flex flex-column min-vh-100" data-bs-theme="dark">
          <Header />
          <div className="flex-grow-1 my-4" style={{ fontFamily: 'Montserrat Medium, Arial, sans-serif', backgroundColor: 'transparent' }} data-bs-theme="dark">
            {pageContent}
          </div>
          <div className="footer mt-auto">
            <Footer />
          </div>
        </div>
        <CookieNotice />
      </>
    );
  }
}

const root = createRoot(document.getElementById('root'));
root.render(<App />);
